export default "__VITE_ASSET__019113df__"